import {
    Box,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Select,
    styled,
    TextField,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { Section } from '../../../components/Section';
import { useApiCall } from '../../../lib/useApiCall';
import { api } from '../../../lib/api';
import { useNavigate } from 'react-router-dom';
import { pathHandler } from '../../../lib/pathHandler';
import { Button } from '../../../components/Button';
import { FormLayout } from '../../../components/FormLayout';
import { GenderSelection } from '../components/GenderSelection';
import { previousProfessionType, referenceType } from './types';
import { PreviousProfession } from './PreviousProfession';
import { Reference } from './Reference';
import { yearMapping, YEARS, yearType } from '../constants';
import { Attachments } from './Attachments';
import { formationInitialeDtoType } from '../../../lib/api/api';
import { genderType } from '../types';

function FormationInitiale() {
    const [formTextData, setTextFormData] = useState({
        firstName: '',
        lastName: '',
        birthdate: '',
        placeOfBirth: '',
        nationality: '',
        email: '',
        phoneNumber: '',
        address: '',
        zipCode: '',
        town: '',
        lastDiploma: '',
        lastEstablishment: '',
        otherDiploma: '',
        parent1FirstName: '',
        parent1LastName: '',
        parent1Address: '',
        parent1Email: '',
        parent1ZipCode: '',
        parent1Town: '',
        parent1PhoneNumber: '',
        parent2FirstName: '',
        parent2LastName: '',
        parent2Address: '',
        parent2ZipCode: '',
        parent2Town: '',
        parent2Email: '',
        parent2PhoneNumber: '',
        motivation: '',
    });
    const [selectedPromo, setSelectedPromo] = useState<yearType | undefined>();
    const [assertion, setAssertion] = useState<boolean>(false);

    const [gender, setGender] = useState<genderType | undefined>();
    const [reference, setReference] = useState<referenceType | undefined>();
    const [previousProfession, setPreviousProfession] = useState<
        previousProfessionType | undefined
    >();

    const navigate = useNavigate();

    const createFormationInitialeEntryApiCall = useApiCall({
        apiCall: api.createFormationInitialeEntry,
        onSuccess: () => {
            navigate(pathHandler.getRoutePath('FORMATION_INITIALE_SUCCESS'));
        },
    });

    return (
        <FormLayout handleSubmit={handleSubmit} title="BACHELOR / MASTER" subtitle="Candidature">
            <Row>
                <Typography variant="h3">Candidature en * : </Typography>
                <Box minWidth={'14vw'}>
                    <Select
                        fullWidth
                        required
                        value={selectedPromo}
                        onChange={(e) => setSelectedPromo(e.target.value as yearType)}
                    >
                        {YEARS.map((YEAR) => (
                            <MenuItem value={YEAR}>{yearMapping[YEAR]}</MenuItem>
                        ))}
                    </Select>
                </Box>
            </Row>
            <Section variant="h2" title="1. Informations personnelles">
                <Row>
                    <TextField
                        fullWidth
                        onChange={handleFormChange}
                        required
                        label="Prénom(s)"
                        placeholder="Jeanne, Marie, Sofia"
                        name="firstName"
                        value={formTextData.firstName}
                    />
                    <TextField
                        fullWidth
                        onChange={handleFormChange}
                        required
                        label="Nom"
                        placeholder="Dupont"
                        name="lastName"
                        value={formTextData.lastName}
                    />
                </Row>
                <Row>
                    <GenderSelection gender={gender} setGender={setGender} />
                </Row>
                <Row>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Date de naissance"
                            type="date"
                            name="birthdate"
                            placeholder="JJ/MM/AAAA"
                            value={formTextData.birthdate}
                            InputLabelProps={{ shrink: true }}
                        />
                    </TextFieldContainer>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Lieu de naissance"
                        fullWidth
                        placeholder="Paris (75)"
                        name="placeOfBirth"
                        value={formTextData.placeOfBirth}
                    />
                    <TextFieldContainer width="28vw">
                        <TextField
                            style={{ width: '28vw' }}
                            onChange={handleFormChange}
                            required
                            label="Nationalité"
                            placeholder="Française"
                            name="nationality"
                            value={formTextData.nationality}
                        />
                    </TextFieldContainer>
                </Row>
                <Row>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Email"
                        type="email"
                        placeholder="jeanne.dupont@email.com"
                        name="email"
                        fullWidth
                        value={formTextData.email}
                    />
                    <TextFieldContainer width="28vw">
                        <TextField
                            style={{ width: '28vw' }}
                            onChange={handleFormChange}
                            required
                            type="tel"
                            placeholder="06 12 34 56 78"
                            label="Téléphone portable"
                            name="phoneNumber"
                            value={formTextData.phoneNumber}
                        />
                    </TextFieldContainer>
                </Row>
                <Row>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Adresse"
                        name="address"
                        value={formTextData.address}
                        fullWidth
                    />
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            type="number"
                            label="Code postal"
                            name="zipCode"
                            value={formTextData.zipCode}
                        />
                    </TextFieldContainer>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Ville"
                            name="town"
                            value={formTextData.town}
                        />
                    </TextFieldContainer>
                </Row>
            </Section>
            <Section variant="h2" title="2. Parcours">
                <Row>
                    <TextField
                        name="lastDiploma"
                        required
                        onChange={handleFormChange}
                        label="Diplôme en cours d'acquisition ou dernier diplôme obtenu"
                        placeholder="Baccalauréat, DUT, BTS, Licence..."
                        fullWidth
                        value={formTextData.lastDiploma}
                    />
                    <TextField
                        name="lastEstablishment"
                        onChange={handleFormChange}
                        required
                        fullWidth
                        label="Établissement actuel ou dernier établissement fréquenté"
                        value={formTextData.lastEstablishment}
                    />
                </Row>

                <TextField
                    name="otherDiploma"
                    onChange={handleFormChange}
                    label="Autres diplômes obtenus (facultatif)"
                    fullWidth
                    value={formTextData.otherDiploma}
                />
                <PreviousProfession
                    previousProfession={previousProfession}
                    setPreviousProfession={setPreviousProfession}
                />
            </Section>
            <Section title="3. Parents ou tuteurs" variant="h2">
                <Section variant="h3" title="Premier parent ou tuteur">
                    <Row>
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            required
                            label="Prénom"
                            name="parent1FirstName"
                            value={formTextData.parent1FirstName}
                        />
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            required
                            label="Nom"
                            placeholder="Dupont"
                            name="parent1LastName"
                            value={formTextData.parent1LastName}
                        />
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            required
                            label="Adresse"
                            name="parent1Address"
                            value={formTextData.parent1Address}
                            fullWidth
                        />
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                required
                                type="number"
                                label="Code postal"
                                name="parent1ZipCode"
                                value={formTextData.parent1ZipCode}
                            />
                        </TextFieldContainer>
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                required
                                label="Ville"
                                name="parent1Town"
                                value={formTextData.parent1Town}
                            />
                        </TextFieldContainer>
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            required
                            label="Email"
                            type="email"
                            placeholder="jeanne.dupont@email.com"
                            name="parent1Email"
                            fullWidth
                            value={formTextData.parent1Email}
                        />
                        <TextFieldContainer width="28vw">
                            <TextField
                                style={{ width: '28vw' }}
                                onChange={handleFormChange}
                                required
                                type="tel"
                                placeholder="06 12 34 56 78"
                                label="Téléphone portable"
                                name="parent1PhoneNumber"
                                value={formTextData.parent1PhoneNumber}
                            />
                        </TextFieldContainer>
                    </Row>
                </Section>
                <Section variant="h3" title="Deuxième parent ou tuteur">
                    <Row>
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            required
                            label="Prénom"
                            name="parent2FirstName"
                            value={formTextData.parent2FirstName}
                        />
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            required
                            label="Nom"
                            placeholder="Dupont"
                            name="parent2LastName"
                            value={formTextData.parent2LastName}
                        />
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            label="Adresse (si différente de celle du parent / tuteur 1)"
                            name="parent2Address"
                            value={formTextData.parent2Address}
                            fullWidth
                        />
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                required={!!formTextData.parent2Address}
                                label="Code postal"
                                type="number"
                                name="parent2ZipCode"
                                value={formTextData.parent2ZipCode}
                            />
                        </TextFieldContainer>
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                required={!!formTextData.parent2Address}
                                label="Ville"
                                name="parent2Town"
                                value={formTextData.parent2Town}
                            />
                        </TextFieldContainer>
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            required
                            label="Email"
                            type="email"
                            name="parent2Email"
                            fullWidth
                            value={formTextData.parent2Email}
                        />
                        <TextFieldContainer width="28vw">
                            <TextField
                                style={{ width: '28vw' }}
                                onChange={handleFormChange}
                                required
                                type="tel"
                                placeholder="06 12 34 56 78"
                                label="Téléphone portable"
                                name="parent2PhoneNumber"
                                value={formTextData.parent2PhoneNumber}
                            />
                        </TextFieldContainer>
                    </Row>
                </Section>
            </Section>
            <Section
                title="4. En quelques lignes, expliquez vos motivations à intégrer l’ésaj"
                variant="h2"
            >
                <TextField
                    onChange={handleFormChange}
                    required
                    label="Préciser ici vos motivations"
                    name="motivation"
                    multiline
                    rows={4}
                    fullWidth
                />
            </Section>
            <Section title="5. Comment avez-vous connu l’ésaj ?" variant="h2">
                <Reference reference={reference} setReference={setReference} />
            </Section>
            <Section title="6. Pièce à joindre à la candidature" variant="h2">
                <Attachments />
            </Section>

            <AssertionContainer>
                <FormControlLabel
                    required
                    control={<Checkbox checked={assertion} />}
                    onChange={(_, checked) => setAssertion(checked)}
                    label="Je certifie exacts les renseignements fournis et m'engage à envoyer par e-mail les pièces justificatives demandées."
                />
            </AssertionContainer>
            <Button
                loadingText="Envoi de la candidature en cours... Cela peut prendre quelques secondes."
                isLoading={createFormationInitialeEntryApiCall.isLoading}
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
            >
                ENVOYER LA CANDIDATURE
            </Button>
        </FormLayout>
    );

    function computeGenderDto() {
        if (gender === undefined) {
            return '';
        }
        if (gender.kind === 'other') {
            return gender.value;
        }
        return gender.kind;
    }

    function computeReferenceDto() {
        if (reference === undefined) {
            return '';
        }
        if (reference.kind === 'socialMedia') {
            if (reference.choice === undefined) {
                return '';
            }
            if (reference.choice.kind === 'other') {
                return `socialMedia - other - ${reference.choice.value}`;
            }
            return `socialMedia - ${reference.choice.kind}`;
        }
        return `${reference.kind} - ${reference.value}`;
    }

    function computeFormationInitialeDto(): formationInitialeDtoType {
        return {
            selectedPromo: selectedPromo ? selectedPromo.trim() : '',
            firstName: formTextData.firstName,
            lastName: formTextData.lastName,
            birthdate: formTextData.birthdate,
            placeOfBirth: formTextData.placeOfBirth,
            nationality: formTextData.nationality,
            email: formTextData.email,
            phoneNumber: formTextData.phoneNumber,
            address: formTextData.address,
            zipCode: formTextData.zipCode,
            town: formTextData.town,
            gender: computeGenderDto(),
            lastDiploma: formTextData.lastDiploma,
            lastEstablishment: formTextData.lastEstablishment,
            otherDiploma: formTextData.otherDiploma,
            reference: computeReferenceDto(),
            previousProfession:
                previousProfession?.kind === 'yes' ? previousProfession.description : null,
            parent1FirstName: formTextData.parent1FirstName,
            parent1LastName: formTextData.parent1LastName,
            parent1Address: formTextData.parent1Address,
            parent1Email: formTextData.parent1Email,
            parent1ZipCode: formTextData.parent1ZipCode,
            parent1Town: formTextData.parent1Town,
            parent1PhoneNumber: formTextData.parent1PhoneNumber,
            parent2FirstName: formTextData.parent2FirstName,
            parent2LastName: formTextData.parent2LastName,
            parent2Address: formTextData.parent2Address,
            parent2ZipCode: formTextData.parent2ZipCode,
            parent2Town: formTextData.parent2Town,
            parent2Email: formTextData.parent2Email,
            parent2PhoneNumber: formTextData.parent2PhoneNumber,
            motivation: formTextData.motivation,
        };
    }

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        const formationInitialeDto = computeFormationInitialeDto();
        createFormationInitialeEntryApiCall.perform(formationInitialeDto);
    }

    function handleFormChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = event.target;
        setTextFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
}

const TextFieldContainer = styled('div')<{ width: string }>(({ theme, width }) => ({
    width,
}));

const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
}));
const AssertionContainer = styled('div')(({ theme }) => ({ paddingTop: theme.spacing(10) }));

export { FormationInitiale };
